module.exports = __webpack_public_path__ + "static/media/Wipro.70f535c9.png";